import React from 'react';
import '../styles/EndScreen.css';

const EndScreen = ({ onPlayAgain }) => {
  return (
    <div className="end-screen">
      <div className="end-content">
        <h1 className="end-title">READY TO PLAY.</h1>
        <p className="end-subtitle">You cleared all 5 levels.</p>
        <p className="end-description">That's the whole story. Now you know who you're hiring.</p>
        
        <div className="end-actions">
          <a 
            href="mailto:shreshthaa003@gmail.com" 
            className="email-button"
          >
            shreshthaa003@gmail.com
          </a>
          
          <button className="play-again-button" onClick={onPlayAgain}>
            Play again
          </button>
        </div>
      </div>
    </div>
  );
};

export default EndScreen;
